import { useEventBus } from '../EventBus';
/**
 * A hook that subscribe to EventBus and gets the value of the variant of the
 * wide header.
 *
 * @returns {[number | null, (value: number | null) => void]} A tuple similar to
 * the return value from React's useState.  The first element is the current
 * value, and the second element is the setter (the post method) to change the
 * variant of the wide header.
 *
 * @example post method usage:
 * import { useWideHeaderVariantEventBus } from '@catawiki/runtime-toolkit';
 * ...
 * const { variant } = useTreatment(AB_SNR_WIDE_HEADER);
 * const [, post] = useWideHeaderVariantEventBus(0);
 * useEffect(() => {
 *   post(variant ?? 0);
 * }, [post, variant]);
 *
 * @example value method usage:
 * import { useWideHeaderVariantEventBus } from '@catawiki/runtime-toolkit';
 * ...
 * const [variant] = useWideHeaderVariantEventBus(0);
 * const isWideHeaderEnabled = variant === 1;
 */
export const useWideHeaderVariantEventBus = (initialValue) => {
    const channel = 'wide-header';
    return useEventBus(channel, initialValue);
};
